import { Notes, Head, Appear } from "mdx-deck";
import lmcLogo from "../../../../../../images/lmc-logo.png";
import zeroConfiguration from "../../../../../../images/stdout-error-mode.jpg";
import webpackMerge from "../../../../../../images/webpack-merge.png";
import newStack from "../../../../../../images/new-stack.png";
import onPremises from "../../../../../../images/on-premises.png";
import cloud from "../../../../../../images/cloud.png";
import serverless from "../../../../../../images/serverless.png";
import evolution from "../../../../../../images/evolution.png";
import fullstackServerless from "../../../../../../images/fullstack-serverless.png";
import fullstackServerless2 from "../../../../../../images/fullstack-serverless2.png";
import tools from "../../../../../../images/tools.png";
import { default as customTheme } from "../../../../../../src/theme";
import * as React from 'react';
export default {
  Notes: Notes,
  Head: Head,
  Appear: Appear,
  lmcLogo: lmcLogo,
  zeroConfiguration: zeroConfiguration,
  webpackMerge: webpackMerge,
  newStack: newStack,
  onPremises: onPremises,
  cloud: cloud,
  serverless: serverless,
  evolution: evolution,
  fullstackServerless: fullstackServerless,
  fullstackServerless2: fullstackServerless2,
  tools: tools,
  customTheme: customTheme,
  React: React
};